import { Transform, Type } from "class-transformer";
import { toHours } from "@/utils/numberUtils";
import { PayrollCalendarViewPlusDto } from "@/core/features/payrolls/payroll-calendar-view-plus.dto";

export class PayrollCalendarViewDayDto {
  dayKey: string;

  @Type(() => Date)
  date: Date;

  isWeekend: boolean;

  isNonWorkDay: boolean;

  hasOnCall: boolean;

  isProductivityCancelledByPoints: boolean;

  isActivationEligibleDay: boolean;

  validatedWorkMinutes: number;

  validatedTravelMinutes: number;

  @Transform(({ value }) => toHours(value))
  validatedMinutes: number;

  @Transform(({ value }) => toHours(value))
  referenceMinutes: number;

  isOvertime: boolean;

  isUndertime: boolean;

  @Type(() => PayrollCalendarViewPlusDto)
  pluses: PayrollCalendarViewPlusDto[];
}
